import { cloneDeep } from "lodash";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../Utils/i18next/i18next";

export const onSubmit = async (values, props) => {
  const { update, updateSingleRegistry, updateTableRegistry, el } = props;
  const data = cloneDeep(values);
  const workers = data?.toUser?.map((el) => el.uuid);
  delete data.toUser;

  if (!update) {
    const { payload } = await GlobalAuthFetch({
      path: `/attachments/shareFileStorage/${el?.uuid}`,
      method: "POST",
      data: workers,
    });

    if (payload?.status >= 300 || !payload?.status) {
      props.setErrorHeader(0, true);
      return;
    }
  }

  props.setErrorHeader(0, false);

  props.loadData();
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  NotificationManager.success(i18n.t("global:success"));
  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (!values.toUser || values.toUser?.length <= 0) {
    errorsStep0.toUser = i18n.t("global:attachments.errors.toUser");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
